import { useState } from "react";
import { adminFetch } from "../../../lib/adminApi";
import { toast } from "sonner";

export function useBlogStaging(onRefresh: () => void) {
  const [activeDraft, setActiveDraft] = useState<any>(null);

  const saveDraft = async (slug: string, payload: any) => {
    try {
      await adminFetch("/api/admin/drafts", {
        operation: "save",
        item_type: "blog",
        item_id: slug,
        draft_data: payload,
      });
      setActiveDraft(payload);
      toast.success("Blog draft saved to staging successfully!");
      onRefresh();
      return true;
    } catch (err: any) {
      toast.error(err.message || "Failed to save draft");
      return false;
    }
  };

  const discardDraft = async (slug: string, livePost: any, restoreForm: (post: any) => void) => {
    if (!confirm("Are you sure you want to discard this staged draft?")) return;
    try {
      await adminFetch("/api/admin/drafts", {
        operation: "delete",
        item_type: "blog",
        item_id: slug,
      });
      setActiveDraft(null);
      if (livePost) {
        restoreForm(livePost);
      }
      toast.success("Draft discarded. Reverted editor to live version.");
      onRefresh();
    } catch (err: any) {
      toast.error(err.message || "Failed to discard draft");
    }
  };

  return {
    activeDraft,
    setActiveDraft,
    saveDraft,
    discardDraft,
  };
}
